var map = {
	"./areaHighlightDialog.md": [
		7162,
		162
	],
	"./aspectsAreaHighlightDialog.md": [
		4301,
		301
	],
	"./cyclesDialog.md": [
		6950,
		950
	],
	"./declinationStudyDialog.md": [
		1432,
		432
	],
	"./horizontalLineDialog.md": [
		4587,
		587
	],
	"./locationSettingsDialog.md": [
		1979,
		979
	],
	"./longitudeStudy.md": [
		7263,
		263
	],
	"./notesReferenceDialog.md": [
		4803,
		803
	],
	"./patternConfigDialog.md": [
		2601,
		601
	],
	"./planetFollowStudyDialog.md": [
		2173,
		173
	],
	"./planetaryLinesDialog.md": [
		485,
		866
	],
	"./strategy2DesignDialog.md": [
		3030,
		30
	],
	"./strategyDesignDialog.md": [
		8222,
		222
	],
	"./timeAndEventStrategyDialog.md": [
		6886,
		886
	],
	"./visualUniverseDialog.md": [
		7926,
		926
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9339;
module.exports = webpackAsyncContext;